import React, { FC } from 'react'

import { Icon, Txt } from 'src/components/atoms'

type Props = {
  disabled: boolean
  onClick: () => void
  className?: string
}

export const ProjectSearchReset: FC<Props> = ({ disabled, onClick, className }) => {
  return (
    <div className={className}>
      <div
        role="presentation"
        className={`tw-flex tw-items-center ${
          disabled ? 'tw-cursor-default' : 'tw-cursor-pointer'
        }`}
        onClick={() => !disabled && onClick()}
      >
        <Txt
          sizeType="s"
          className={`tw-font-bold tw-mr-s-4 ${
            disabled ? 'tw-text-standardText-disable' : 'tw-text-standardText-primary'
          }`}
        >
          リセット
        </Txt>
        <Icon
          size="--r-1"
          path="refresh-ccw/soft/line"
          className={disabled ? 'tw-text-standardText-disable' : 'tw-text-standardText-secondary'}
        />
      </div>
    </div>
  )
}
